export enum PhoneBookType {
  PRIVATE = 'PRIVATE',
  CALL_CENTER = 'CALL_CENTER',
  ENTERPRISE = 'ENTERPRISE',
  CORPORATE = 'CORPORATE',
  GROUP = 'GROUP',
  SYSTEM = 'SYSTEM',
}
